import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';

import { texts } from 'utils/languages/fr';

import { ConfirmDialog, RadioLabel } from 'components';
import { RadioGroup } from '@mui/material';
import { parseSum } from 'utils/helpers';

const SubcategoryDialog = ({ open, onConfirm, onClose, subcategories, loading }) => {
    const [selectedSubcategory, setSelectedSubcategory] = useState(
        subcategories.find(sc => !sc.reserved)?.id || ''
    );

    useEffect(() => {
        if (!open) {
            setSelectedSubcategory('');
        } else {
            setSelectedSubcategory(
                prevState => subcategories.find(sc => !sc.reserved)?.id || prevState
            );
        }
    }, [open, subcategories]);

    return (
        <ConfirmDialog
            title={texts.CHOSING_SUBCATEGORY}
            open={open}
            handleClose={onClose}
            handleConfirm={onConfirm(selectedSubcategory)}
            confirmText={texts.SAVE}
            cancelText={texts.CANCEL}
            loading={loading}
        >
            <RadioGroup
                row
                name="share-subcategory"
                value={selectedSubcategory}
                onChange={e => setSelectedSubcategory(e.target.value)}
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'flex-start',
                }}
            >
                {subcategories.map(sc => (
                    <RadioLabel
                        key={sc.id}
                        value={sc.id}
                        label={`${sc.name} : ${parseSum(sc.minInvestedAmount)}${
                            sc.maxInvestedAmount ? ' - ' + parseSum(sc.maxInvestedAmount) : ' + '
                        }${sc.reserved ? ' ' + texts.RESERVED : ''}`}
                    />
                ))}
            </RadioGroup>
        </ConfirmDialog>
    );
};

SubcategoryDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    subcategories: PropTypes.array,
    loading: PropTypes.bool,
};

export default SubcategoryDialog;
